import { ReactNode } from 'react';
import type { TableProps } from 'antd';

import { PaginationModel } from '@shared/common/hooks/usePagination';
import DataTablePanel from '@shared/components/DataTablePanel/DataTablePanel';
import dashboardStyles from '@shared/components/Dashboard/Dashboard.module.scss';
import { Title } from '@shared/components/typography';
import { TitleTag, TitleVariant } from '@shared/components/typography/Title';

export interface CallbackRequestsProps<T extends object> {
  title: string;
  description?: string;
  toolbar?: ReactNode;
  sectionTitle: string;
  totalLabel?: ReactNode;
  errorMessage?: ReactNode;
  loading?: boolean;
  rowKey: TableProps<T>['rowKey'];
  columns: TableProps<T>['columns'];
  dataSource: T[];
  pagination: PaginationModel;
  totalItems?: number;
  onChangePagination?: (pageSize: number, page: number) => void;
  scroll?: TableProps<T>['scroll'];
  pageSizeOptions?: string[];
  simplePagination?: boolean;
}

const CallbackRequests = <T extends object>(props: CallbackRequestsProps<T>) => {
  const {
    title,
    description,
    toolbar,
    sectionTitle,
    totalLabel,
    errorMessage,
    loading = false,
    rowKey,
    columns,
    dataSource,
    pagination,
    totalItems,
    onChangePagination,
    scroll = { x: 'max-content' },
    pageSizeOptions,
    simplePagination = true,
  } = props;

  return (
    <div>
      <Title tag={TitleTag.h1} variant={TitleVariant.main}>
        <span>{title}</span>
      </Title>
      <div className={dashboardStyles.wrapper}>
        {toolbar ? <div className={dashboardStyles.headerMini}>{toolbar}</div> : null}
        <DataTablePanel<T>
          sectionTitle={sectionTitle}
          description={description}
          totalLabel={totalLabel}
          errorMessage={errorMessage}
          columns={columns}
          data={dataSource}
          pagination={pagination}
          totalItems={totalItems}
          loading={loading}
          rowKey={rowKey}
          scroll={scroll}
          onChangePagination={onChangePagination}
          pageSizeOptions={pageSizeOptions}
          simplePagination={simplePagination}
        />
      </div>
    </div>
  );
};

export default CallbackRequests;
